import React, { Component } from 'react'
import {Container,Row, Card ,Col } from 'reactstrap'
import { Modal, Button } from "react-bootstrap";
import {Link} from 'react-router-dom'
import {API_CANDIDATE} from "../../utils/config"
import {getApplyJobs} from "../../redux/action/jobs/apply_jobsAction"
import {getProfileInfo} from "../../redux/action/profileInfoAction"
import { connect } from 'react-redux'
import axios from 'axios'
import DateFns from "date-fns";




 class ViewApplyJobs extends Component {
     constructor(){
     super()
     this.state = {
      data:[],
      store:[],
      edit:false,
      storeData:[]
     }  
     this.handleViewClick = this.handleViewClick.bind(this)
     this.backNavigate = this.backNavigate.bind(this)  
     }

    componentDidMount(){
     this.props.getProfileInfo()
  }

  
  componentDidUpdate(prevProps,prevState){
   if(prevProps.profile.data !== this.props.profile.data){
    this.props.getApplyJobs(this.props.profile.data.id)
    }
    }

     getData() {
       axios
          .get(`${API_CANDIDATE}/v1/api/can-skill`, { withCredentials: true })
          .then((res) => {
            console.log(res);
           this.setState({
              data: res.data,
            });
          })
          .catch((err) => {
            console.log("err", err);
          });
      }

      handleViewClick(data){
        this.setState({
        isEdit:!this.state.isEdit,     
        storeData:[data],
        })
    
         }
    
         backNavigate(){
            this.setState({
                isEdit:false,     
             })
        }
    render() {
                 for(let i = 0 ; i < this.state.data.length ; i++){
                    this.state.store.push(this.state.data[i].skill)
                   }
    
    
       
       
        return (
            <div>
          <Container
            style={{ width: "80%", marginTop: "40px !important" }}
            className="card container-card migrator-mt personalDetails-div-1  "
          >
            <Link to = "/dashboard">
            <i
              className="material-icons contact-cancel-button pointer">
              cancel
            </i>
           
            </Link>
            <Row className='scrollmenu'>
          { !this.state.isEdit &&  <div style={{width:"100%",display:"flex",fontSize:"1.2rem",justifyContent:"center"}}>
           <span style={{ fontSize:"1.25rem",fontWeight:"500"}}> Jobs</span>
           </div>  }

           
           { !this.state.isEdit && <Col md="12" className="p-0">
              <ul className="crm-flex-around  ul-head ">
                <li
                  style={{ width: "10%",   fontSize: "14px",
                  fontWeight: "500", }}
                  className="list-crm-item bold pad-rs-name margin_res"
                >
                  Job Id
                </li>
                <li
                  style={{ width: "10%",   fontSize: "14px",
                  fontWeight: "500", }}
                  className="list-crm-item bold pad-rs-name margin_res"
                >
                  Req Id
                </li>
                <li  style={{
                  
                  fontSize: "14px",
                  fontWeight: "500",
                }} className="list-crm-item bold pad-rs-name margin_res">
                  Job Type
                </li>
                <li  style={{
                  
                  fontSize: "14px",
                  fontWeight: "500",
                }} className="list-crm-item bold pad-rs-name margin_res">Job Position</li>

                <li  style={{
                  
                  fontSize: "14px",
                  fontWeight: "500",
                }} className="list-crm-item bold pad-rs-name margin_res">Job Description</li>
                <li  style={{
                  
                  fontSize: "14px",
                  fontWeight: "500",
                }} className="list-crm-item bold pad-rs-name mar_left margin_res"> Job Location</li>
                <li  style={{
                  
                  fontSize: "14px",
                  fontWeight: "500",
                }} className="list-crm-item bold pad-rs-name margin_res"> Job Status</li>

          
              </ul>
            </Col>}
           { !this.state.isEdit && this.props.ApplyJobs.data.length > 0 &&
               this.props.ApplyJobs.data.map((item) => {
                return (
                  <Col md="12" className="p-0" key={item.id}>
                    <ul
                      // onClick={() => this.handleViewClick(item)}
                      className="rs-flex-around mar_left_ul"
                      // onClick={() => {
                      //   select(item);
                      // }}

                      // onMouseEnter={(e) => this.toggleHoverOn(e, item)}
                      // onMouseLeave={this.toggleHoverOff}
                    >
                      <li
                        style={{ width: "10%", paddingLeft: "2%" }}
                        className="list-crm-table-item pad-rs-name margin_res overlap_text"
                      >
                        {item.jobId}
                      </li>
                      <li
                        style={{ width: "10%", paddingLeft: "2%" }}
                        className="list-crm-table-item pad-rs-name margin_res margin_id overlap_text"
                      >
                        {item.jobRequirementId}
                      </li>
                      <li
                      style={{}}
                        className="list-crm-table-item pad-rs-name margin_res overlap_text"
                      >
                        {item.jobReqType}
                      </li>
                     
                      <li
                        style={{}}
                        className="list-crm-table-item pad-rs-name margin_res overlap_text"
                      >
                        {item.jobPosition}
                      </li>

                      <li
                         style={{}}
                        className="list-crm-table-item pad-rs-name margin_res overlap_text"
                      >
                        {item.jobDescription}
                      </li>
                      <li
                       style={{overflow:'hidden'}}
                        className="list-crm-table-item pad-rs-name mar_left margin_res "
                      >
                       {item.jobLocation}
                      </li>
                      <li
                         style={{}}
                        className="list-crm-table-item pad-rs-name margin_res overlap_text"
                      >
                         {item.candidateStatus}
                      </li>
                    
                    
                    </ul>
                  </Col>
                );
              })}
          </Row>
          {/* {
          this.state.isEdit && <ParticularMatchedJobs back ={this.backNavigate} storeData = {this.state.storeData}/>
          } */}
          </Container>  
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    MatchedJobs:state.MatchedJobs,
    profile: state.profile,
    ApplyJobs: state.ApplyJobs,
})


export default connect(mapStateToProps,{
  getApplyJobs,
  getProfileInfo
})(ViewApplyJobs)
